// Test-receipt download.
//
// A single static PDF served from `public/`, not a generated document. There
// is no order on the server to render from, and hand-rolling a PDF writer in
// the browser is a trap: correct byte (not character) xref offsets, fixed-width
// xref entries, `\`/`(`/`)`/CR/LF escaping, encoded stream lengths, and a
// Unicode-capable embedded font once the copy is translated. None of that is
// worth carrying for a document that cannot yet contain real data.
//
// Served from `public/` specifically because production ships only the Vite
// `dist` output — anything under `docs/` would 404.
//
// The file itself is labelled SANDBOX / TEST ONLY / NO PAYMENT TAKEN, so it
// cannot be mistaken for an invoice if it is forwarded or filed. Replace this
// with `GET /billing/receipts/{id}/pdf` when real orders exist.
export const SAMPLE_RECEIPT_URL = '/billing/sample-receipt.pdf'
